import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import NewsletterSignup from './NewsletterSignup';

/**
 * Footer - TasteSkill Premium Redesign
 * 
 * Verbesserungen:
 * - Professionelleres Layout
 * - Klickbare Kontaktdaten
 * - Einheitliche Designsprache
 */

const Footer = () => {
  return (
    <footer className="bg-[#0B1930] text-gray-300">
      {/* Disclaimer Section */}
      <div className="border-b border-gray-700/30">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="max-w-3xl">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Hinweis</h3>
            <div className="text-sm text-gray-500 leading-relaxed space-y-1">
              <p>Firmbay ist ein Angebot der Interpohl Solutions GmbH und dient der Vermittlung von Gesellschaftsangeboten.</p>
              <p>Wir bieten keine Rechts- oder Steuerberatung an und verkaufen keine Gesellschaften.</p>
              <p>Die Plattform dient der Vermittlung und organisatorischen Begleitung von GmbH-Gründungen, Vorratsgesellschaften sowie Gesellschafterübertragungen.</p>
              <p>Sämtliche gesellschaftsrechtlichen Vorgänge erfolgen ausschließlich durch Notare und externe, eigenverantwortliche Partner.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/firmbay-logo.png" 
              alt="Firmbay Logo" 
              className="h-12 w-auto brightness-0 invert opacity-80"
            />
            <p className="text-sm text-gray-500 leading-relaxed">
              Vermittlung von GmbH-Gründungen und Bestandsgesellschaften in Deutschland.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Navigation</h3>
            <ul className="space-y-2.5">
              {[
                { path: '/marktplatz', label: 'GmbH kaufen' },
                { path: '/seller-onboarding', label: 'GmbH verkaufen' },
                { path: '/onboarding', label: 'GmbH gründen' },
                { path: '/ueber-uns', label: 'Über uns' },
                { path: '/kontakt', label: 'Kontakt' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-gray-400 hover:text-[#009E9A] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Rechtliches</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/rechtliches" className="text-sm text-gray-400 hover:text-[#009E9A] transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/rechtliches#datenschutz" className="text-sm text-gray-400 hover:text-[#009E9A] transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/rechtliches#agb" className="text-sm text-gray-400 hover:text-[#009E9A] transition-colors">
                  AGB
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:info@firmbay.de" className="flex items-start gap-3 group">
                  <Mail className="w-4 h-4 text-[#009E9A] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-gray-400 group-hover:text-[#009E9A] transition-colors">
                    info@firmbay.de
                  </span>
                </a>
              </li>
              <li>
                <a href="tel:+491707967959" className="flex items-start gap-3 group">
                  <Phone className="w-4 h-4 text-[#009E9A] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-gray-400 group-hover:text-[#009E9A] transition-colors">
                    0170-7967959
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#009E9A] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">
                  Hansastr. 72<br />44137 Dortmund
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="border-t border-gray-700/30 mt-10 pt-10">
          <div className="max-w-md">
            <h3 className="text-sm font-semibold text-white mb-4">Newsletter</h3>
            <NewsletterSignup variant="footer" />
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700/30 mt-10 pt-6 text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Interpohl Solutions GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
